export var MAX_CHARS = 524288; // the default max length per the html maxlength attribute
export var MIN_SEARCH_LENGTH = 3;
export var PAUSE = 10;
export var TEXT_SEARCHING = "Searching...";
export var TEXT_NO_RESULTS = "No results found";
export var CLEAR_TIMEOUT = 50;
export function isNil(value) {
    return typeof value === "undefined" || value === null;
}
//# sourceMappingURL=globals.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-completer/globals.js
// module id = 42
// module chunks = 8